const setStyles = (config) => {
  const root = document.documentElement;

  // 1. Adicionar variáveis CSS para as cores
  Object.entries(config.colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });

  // 2. Importar as fontes no head
  if (config.typography.source) {
    // Se for string, trata como URL única (comportamento original)
    if (typeof config.typography.source === "string") {
      const link = document.createElement("link");
      link.href = config.typography.source;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    // Se for array, itera sobre cada item
    else if (Array.isArray(config.typography.source)) {
      config.typography.source.forEach((source) => {
        // Se começa com https, é uma URL remota
        if (source.startsWith("https")) {
          const link = document.createElement("link");
          link.href = source;
          link.rel = "stylesheet";
          document.head.appendChild(link);
        }
        // Caso contrário, é uma fonte local
        else {
          // Extrair nome da fonte e extensão do arquivo
          const pathParts = source.split("/");
          const fileName = pathParts[pathParts.length - 1];
          const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, "");
          const extension = fileName.split(".").pop().toLowerCase();

          // Mapear extensão para formato de fonte
          const formatMap = {
            ttf: "truetype",
            otf: "opentype",
            woff: "woff",
            woff2: "woff2",
            eot: "embedded-opentype"
          };
          const fontFormat = formatMap[extension] || "truetype";

          // Criar @font-face no styleTag
          let styleTag = document.getElementById("dynamic-fonts");
          if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "dynamic-fonts";
            document.head.appendChild(styleTag);
          }

          // Adicionar @font-face
          const fontFace = `@font-face {
            font-family: '${fileNameWithoutExt}';
            src: url('/${source}') format('${fontFormat}');
          }\n`;
          styleTag.innerHTML += fontFace;
        }
      });
    }
  }

  // 3. Criar um estilo global para aplicar os H1, H2, etc.
  let styleTag = document.getElementById("dynamic-styles");
  if (!styleTag) {
    styleTag = document.createElement("style");
    styleTag.id = "dynamic-styles";
    document.head.appendChild(styleTag);
  }

  let styles = "";
  Object.entries(config.typography).forEach(([tag, props]) => {
    if (typeof props === "object") {

      let selectors = tag.toLowerCase();

      if (tag === "P") {
        selectors += ", div, input";
      }

      styles += `${selectors} {
          font-size: ${props.font_size};
          line-height: ${props.line_height};
          letter-spacing: ${props.letter_spacing}px;
          font-family: '${props.font_family}', sans-serif;
          font-weight: ${props.font_weight};
          font-style: ${props.font_style || "normal"};
          text-transform: ${props.text_transform || 'inherit'}
        }\n`;
    }
  });

  styleTag.innerHTML = styles;
};

export default setStyles;
